import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Permission = iotsUtils.fromList(constants.acs.permission);
